import { ComponentType } from '@angular/cdk/overlay';
import { Injectable, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

// Due to a bug in the Angular Material library, an error sometimes occurs when focus is retained on the active element when opening a dialog.
// This service is a workaround to blur the active element before opening a dialog.
// See https://github.com/angular/components/issues/30187 for more information.
@Injectable({
  providedIn: 'root',
})
export class CustomMatDialogService extends MatDialog {
  override open<T, D = any, R = any>(component: ComponentType<T>, config?: MatDialogConfig<D>): MatDialogRef<T, R>;
  override open<T, D = any, R = any>(template: TemplateRef<T>, config?: MatDialogConfig<D>): MatDialogRef<T, R>;
  override open<T, D = any, R = any>(
    componentOrTemplate: ComponentType<T> | TemplateRef<T>,
    config?: MatDialogConfig<D>
  ): MatDialogRef<T, R> {
    const activeElement = document.activeElement as HTMLElement;
    if (!!activeElement) activeElement.blur();

    return super.open(componentOrTemplate, config);
  }
}
